import { birds } from "./birds";
import { getArtist, resolveArtist } from "./artists";
import { Artist, Bird } from "./types";

/**
 * Uma ilustração = uma mídia de `bird.illustrations`, já com a ave e o artista
 * resolvidos. Uma ave pode ter várias ilustrações (cada uma vira um item).
 */
export interface Illustration {
  /** Caminho da imagem. Único; usado como chave. */
  src: string;
  /** Posição dentro de `bird.illustrations` (usada em /ilustracoes?bird=<id>&img=<index>). */
  index: number;
  /** Nome popular já capitalizado, pronto para exibir. */
  name: string;
  bird: Bird;
  /** Artista canônico (segue `aliasOf`); ausente se a mídia não tem `artistId`. */
  artist?: Artist;
}

// popularName vem em minúsculas no dicionário ("anu-branco")
const capitalize = (s: string): string => s.charAt(0).toUpperCase() + s.slice(1);

// Os dados são estáticos: a lista é montada uma única vez.
// Só entram aves que têm pelo menos uma ilustração em birds.ts.
export const illustrations: Illustration[] = birds.flatMap((bird) =>
  bird.illustrations.map((media, index) => ({
    src: media.src,
    index,
    name: capitalize(bird.popularName),
    bird,
    artist: resolveArtist(getArtist(media.artistId)),
  }))
);

/** Ilustrações de um artista (aceita o id canônico ou um alias). */
export const getIllustrationsByArtist = (artistId: string): Illustration[] => {
  const target = resolveArtist(getArtist(artistId))?.id;
  return target ? illustrations.filter((i) => i.artist?.id === target) : [];
};
